import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: DataEntryScreenBase UI Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.data-entry-screen-base.';

  public static readonly cancelNewEdit = `${Id.prefix}cancelNewEdit`;
  public static readonly discardChanges = `${Id.prefix}discardChanges`;
  public static readonly revertTabChanges = `${Id.prefix}revertTabChanges`;
}

export class LangDataEntryScreenBase {
  private constructor() {}
  public static cancelNewEdit(): string {
    return interpolate(Id.cancelNewEdit);
  }
  public static discardChanges(): string {
    return interpolate(Id.discardChanges);
  }
  public static revertTabChanges(): string {
    return interpolate(Id.revertTabChanges);
  }
}

export class DataEntryScreenBaseModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // DataEntryScreenBase UI Strings
    register.add(Id.cancelNewEdit, 'Cancel New Edit', 'Label for canceling a new edit operation');
    register.add(
      Id.discardChanges,
      'Are you sure you want to discard your changes?',
      'Dialog message for discarding changes'
    );
    register.add(
      Id.revertTabChanges,
      'This will revert all changes you have made on this tab',
      'Dialog message for reverting changes on a tab'
    );
  }
}
